// Shared, persisted user settings (render/UI-side only — never touches the sim).
// Consumed by the audio engine, the renderer (screen shake) and the menus.

export interface Settings {
  shake: boolean; // screen shake on big explosions
  sfxVolume: number; // 0..1 master SFX volume
  muted: boolean; // hard mute
}

const KEY = "torrent.settings.v1";

const DEFAULTS: Settings = { shake: true, sfxVolume: 0.6, muted: false };

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return { ...DEFAULTS };
}

export const settings: Settings = load();

export function saveSettings(): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(settings));
  } catch {
    /* ignore */
  }
}
